import { BaseEntity } from "yt-ng-framework";

export class PodVrstaDokumenta extends BaseEntity{
    constructor(){
        super();
    }

    VrstaDokumentaID:number = null;
    GenericName:string = null;
    Model:string = null;   
    Naziv:string = null;         
    SNaziv:string = null;
    Opis:string = null;
    IsActive:boolean = false;
    DefaultIzvestajID: number = null;
    OdgovornoLiceJeObavezno: boolean = null;

    Deserialize(input:any){
        this.ID=input.ID;
        this.VrstaDokumentaID=input.VrstaDokumentaID;
        this.GenericName=input.GenericName;
        this.Model=input.Model;   
        this.Naziv=input.Naziv;        
        this.SNaziv=input.SNaziv;
        this.Opis=input.Opis;
        this.IsActive = input.IsActive;
        this.DefaultIzvestajID = input.DefaultIzvestajID;
        this.OdgovornoLiceJeObavezno = input.OdgovornoLiceJeObavezno;
        return this;
    }

    Serialize(input:PodVrstaDokumenta){
        return input;
    }
}